module.exports = __webpack_public_path__ + "static/media/timetable smart-03.ac2ce4f4.svg";